import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AnalysesState, AnalysisListItem } from '@/features/ChatBot/interfaces';

import { fetchTokenUsage, getAnalysis, getAnalysesList } from './actions';

const initialState: AnalysesState = {
  analyses: [],
  isEditAnalysisModalOpen: false,
  selectedAnalysis: null,
  isAnalysisViewModalOpen: false,
  isChatBotModalOpen: false,
  chatBotFocusId: null,
  getAnalysisRequestId: null,
  getAnalysisLoading: false,
  getAnalysisError: false,
  tokenUsage: null,
  tokenUsageLoading: false,
  tokenUsageError: false,
};

export const analysesSlice = createSlice({
  name: 'analyses',
  initialState,
  reducers: {
    openEditAnalysisModal: state => {
      state.isEditAnalysisModalOpen = true;
    },
    closeEditAnalysisModal: state => {
      state.isEditAnalysisModalOpen = false;
    },
    openAnalysisViewModal: (state, { payload }: PayloadAction<AnalysisListItem>) => {
      state.selectedAnalysis = payload;
      state.isAnalysisViewModalOpen = true;
    },
    closeAnalysisViewModal: state => {
      state.selectedAnalysis = null;
      state.isAnalysisViewModalOpen = false;
      state.getAnalysisRequestId = null;
      state.getAnalysisLoading = false;
      state.getAnalysisError = false;
    },
    setSelectedAnalysis: (state, { payload }: PayloadAction<AnalysisListItem | null>) => {
      state.selectedAnalysis = payload;
    },
    setAnalysisViewModalOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isAnalysisViewModalOpen = payload;
    },
    openChatBotModal: (state, { payload }: PayloadAction<number | null>) => {
      state.isChatBotModalOpen = true;
      state.chatBotFocusId = payload ?? null;
    },
    closeChatBotModal: state => {
      state.isChatBotModalOpen = false;
      state.chatBotFocusId = null;
    },
  },
  extraReducers: builder =>
    builder
      .addCase(getAnalysesList.fulfilled, (state, { payload }) => {
        state.analyses = payload;
      })
      .addCase(getAnalysis.pending, (state, { meta }) => {
        state.getAnalysisRequestId = meta.arg;
        state.getAnalysisLoading = true;
        state.getAnalysisError = false;
      })
      .addCase(getAnalysis.fulfilled, (state, { meta, payload }) => {
        state.getAnalysisRequestId = meta.arg;
        state.selectedAnalysis = payload;
        state.getAnalysisLoading = false;
      })
      .addCase(getAnalysis.rejected, (state, { meta }) => {
        state.getAnalysisRequestId = meta.arg;
        state.getAnalysisLoading = false;
        state.getAnalysisError = true;
      })
      .addCase(fetchTokenUsage.pending, state => {
        state.tokenUsageLoading = true;
        state.tokenUsageError = false;
      })
      .addCase(fetchTokenUsage.fulfilled, (state, { payload }) => {
        state.tokenUsage = payload;
        state.tokenUsageLoading = false;
        state.tokenUsageError = false;
      })
      .addCase(fetchTokenUsage.rejected, state => {
        state.tokenUsageLoading = false;
        state.tokenUsageError = true;
      }),
});

export const {
  openEditAnalysisModal,
  closeEditAnalysisModal,
  openAnalysisViewModal,
  closeAnalysisViewModal,
  setSelectedAnalysis,
  setAnalysisViewModalOpen,
  openChatBotModal,
  closeChatBotModal,
} = analysesSlice.actions;
export default analysesSlice.reducer;
